import dispatcher from '../dispatcher';

import FormActionConstants from '../constants/actions/form';

const FormActions = {
	addFirstElement(type) {
		dispatcher.handleAction({
			actionType: FormActionConstants.ADD_FIRST_ELEMENT,
			data: {
				elementType: type
			}
		});
	},

	addInputToGroup(fieldsetIndex, rowIndex, elementIndex, type) {
		dispatcher.handleAction({
			actionType: FormActionConstants.ADD_INPUT_TO_GROUP,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				type
			}
		});
	},

	addCustomAnswerFieldToGroup(fieldsetIndex, rowIndex, elementIndex, type) {
		dispatcher.handleAction({
			actionType: FormActionConstants.ADD_CUSTOM_ANSWER_FIELD_TO_GROUP,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				type
			}
		});
	},

	addNewRow(targetFieldsetIndex, targetRowIndex, elementType, insertAfter) {
		dispatcher.handleAction({
			actionType: FormActionConstants.ADD_ROW,
			data: {
				targetFieldsetIndex,
				targetRowIndex,
				elementType,
				insertAfter
			}
		});
	},

	addColumnToTable(fieldsetIndex, rowIndex, elementIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.ADD_TABLE_COLUMN,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex
			}
		});
	},

	addRowToTable(fieldsetIndex, rowIndex, elementIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.ADD_TABLE_ROW,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex
			}
		});
	},

	addOptionToSelectMenu(fieldsetIndex, rowIndex, elementIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.ADD_OPTION_TO_SELECT_MENU,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex
			}
		});
	},

	changeTitle(newFormTitle) {
		dispatcher.handleAction({
			actionType: FormActionConstants.CHANGE_TITLE,
			data: newFormTitle
		});
	},

	changeUrl(newFormUrl) {
		dispatcher.handleAction({
			actionType: FormActionConstants.CHANGE_URL,
			data: newFormUrl
		});
	},

	clearEditMode() {
		dispatcher.handleAction({
			actionType: FormActionConstants.CLEAR_EDIT_MODE,
			data: {}
		});
	},

	initializeInputGroup(fieldsetIndex, rowIndex, elementIndex, type) {
		dispatcher.handleAction({
			actionType: FormActionConstants.INITIALIZE_INPUT_GROUP,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				type
			}
		});
	},

	initializeNewForm() {
		dispatcher.handleAction({
			actionType: FormActionConstants.INITIALIZE,
			data: {}
		});
	},

	initializeTemplateForm(templateData) {
		dispatcher.handleAction({
			actionType: FormActionConstants.INITIALIZE_TEMPLATE_FORM,
			data: templateData
		});
	},

	initializeSelectMenu(fieldsetIndex, rowIndex, elementIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.INITIALIZE_SELECT_MENU,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex
			}
		});
	},

	initializeAddressSTATES(fieldsetIndex, rowIndex, elementIndex){
		dispatcher.handleAction({
			actionType: FormActionConstants.INITIALIZE_ADDRESS_STATES,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex
			}
		});
	},

	initializeAddress(fieldsetIndex, rowIndex, elementIndex){
		dispatcher.handleAction({
			actionType: FormActionConstants.INITIALIZE_ADDRESS,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex
			}
		});
	},

	initializeContact(fieldsetIndex, rowIndex, elementIndex){
		dispatcher.handleAction({
			actionType: FormActionConstants.INITIALIZE_CONTACT,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex
			}
		});
	},

	initializeTable(fieldsetIndex, rowIndex, elementIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.INITIALIZE_TABLE_ELEMENT,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
			}
		});
	},

	load(data) {
		dispatcher.handleAction({
			actionType: FormActionConstants.LOAD,
			data
		});
	},

	moveRow(sourceFieldsetIndex, sourceRowIndex, destinationFieldsetIndex, destinationRowIndex, insertAfter, draggedRowContainsTextBox, textboxIndex = null) {
		dispatcher.handleAction({
			actionType: FormActionConstants.MOVE_ROW,
			data: {
				sourceFieldsetIndex,
				sourceRowIndex,
				destinationFieldsetIndex,
				destinationRowIndex,
				insertAfter,
				containsTextBox: draggedRowContainsTextBox,
				textboxIndex
			}
		});
	},

	moveInputFromGroup(fieldsetIndex, rowIndex, elementIndex, sourceInputIndex, targetInputIndex, elementsKey) {
		dispatcher.handleAction({
			actionType: FormActionConstants.MOVE_INPUT_FROM_GROUP,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				sourceInputIndex,
				targetInputIndex,
				elementsKey
			}
		});
	},

	rebuildForm(data) {
		dispatcher.handleAction({
			actionType: FormActionConstants.REBUILD,
			data
		});
	},

	removeElement(fieldsetIndex, rowIndex, elementIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.REMOVE_ELEMENT,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex
			}
		});
	},

	removeCustomAnswerFieldFromGroup(fieldsetIndex, rowIndex, elementIndex, choiceIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.REMOVE_CUSTOM_ANSWER_FIELD_FROM_GROUP,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				choiceIndex
			}
		});
	},

	removeInputFromGroup(fieldsetIndex, rowIndex, elementIndex, choiceIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.REMOVE_INPUT_FROM_GROUP,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				choiceIndex
			}
		});
	},

	removeOptionFromSelectMenu(fieldsetIndex, rowIndex, elementIndex, optionIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.REMOVE_OPTION_FROM_SELECT_MENU,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				optionIndex
			}
		});
	},

	removeAllOptionsFromSelectMenu(fieldsetIndex, rowIndex, elementIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.REMOVE_ALL_OPTIONS_FROM_SELECT_MENU,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex
			}
		});
	},
	
	removeSettingsKey(key) {
		dispatcher.handleAction({
			actionType: FormActionConstants.REMOVE_SETTINGS_PROPERTY,
			data: {key}
		});
	},

	removeRow(fieldsetIndex, rowIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.REMOVE_ROW,
			data: {
				fieldsetIndex,
				rowIndex
			}
		});
	},

	removeTableColumn(fieldsetIndex, rowIndex, elementIndex, columnIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.REMOVE_TABLE_COLUMN,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				columnIndex
			}
		});
	},

	removeTableRow(fieldsetIndex, rowIndex, elementIndex, subRowIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.REMOVE_TABLE_ROW,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				subRowIndex
			}
		});
	},

	saveRichText(fieldsetIndex, rowIndex, index, content) {
		dispatcher.handleAction({
			actionType: FormActionConstants.SAVE_RICH_TEXT,
			data: {
				fieldsetIndex,
				rowIndex,
				index,
				content
			}
		});
	},

	saveSetting(key, value) {
		dispatcher.handleAction({
			actionType: FormActionConstants.SAVE_SETTING,
			data: {
				key,
				value
			}
		});
	},

	setFormUrlState(state) {
		dispatcher.handleAction({
			actionType: FormActionConstants.SET_FORM_URL_STATE,
			data: state
		});
	},

	setSaveButtonState(state) {
		dispatcher.handleAction({
			actionType: FormActionConstants.SET_SAVE_BUTTON_STATE,
			data: state
		});
	},

	setTableAnswerStyle(fieldsetIndex, rowIndex, elementIndex, style) {
		dispatcher.handleAction({
			actionType: FormActionConstants.SET_TABLE_ANSWER_STYLE,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				style
			}
		});
	},

	toggleEditMode(fieldsetIndex, rowIndex, elementIndex) {
		dispatcher.handleAction({
			actionType: FormActionConstants.TOGGLE_EDIT_MODE,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex
			}
		});
	},

	updateElementModel(fieldsetIndex, rowIndex, index, elementData) {
		dispatcher.handleAction({
			actionType: FormActionConstants.UPDATE_ELEMENT_MODEL,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex: index,
				elementData
			}
		});
	},

	updateGroupedElementLabel(fieldsetIndex, rowIndex, elementIndex, choiceNumber, newLabel) {
		dispatcher.handleAction({
			actionType: FormActionConstants.UPDATE_GROUPED_ELEMENT_LABEL,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				choiceNumber,
				newLabel
			}
		});
	},

	updateCustomGroupedElementLabel(fieldsetIndex, rowIndex, elementIndex, choiceNumber, newLabel) {
		dispatcher.handleAction({
			actionType: FormActionConstants.UPDATE_CUSTOM_GROUPED_ELEMENT_LABEL,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				choiceNumber,
				newLabel
			}
		});
	},

	updateSelectMenuOptionLabel(fieldsetIndex, rowIndex, elementIndex, optionNumber, newLabel) {
		dispatcher.handleAction({
			actionType: FormActionConstants.UPDATE_SELECT_MENU_OPTION_LABEL,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				optionNumber,
				newLabel
			}
		});
	},

	updateTableColumnLabel(fieldsetIndex, rowIndex, elementIndex, columnIndex, newLabel) {
		dispatcher.handleAction({
			actionType: FormActionConstants.UPDATE_TABLE_COLUMN_LABEL,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				columnIndex,
				newLabel
			}
		});
	},

	updateTableRowLabel(fieldsetIndex, rowIndex, elementIndex, subRowIndex, newLabel) {
		dispatcher.handleAction({
			actionType: FormActionConstants.UPDATE_TABLE_ROW_LABEL,
			data: {
				fieldsetIndex,
				rowIndex,
				elementIndex,
				subRowIndex,
				newLabel
			}
		});
	},

	test() {
		dispatcher.handleAction({
			actionType: FormActionConstants.TEST,
			data: {}
		});
	}
}

export default FormActions;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/actions/form.js